import handleCart from '../reducers/handleCart';
import {combineReducers } from "redux";

const rootReducers = combineReducers({
    handleCart,
})

export default rootReducers